"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Button, Dialog, DialogBody, DialogContent, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function ProfileCompleteDialog() {
  const pathname = usePathname();
  const clientConfig = useClientConfig();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="font-bold w-full flex text-base p-6">Lamar Sekarang</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle></DialogTitle>
        <DialogBody>
          <div>
            <Image
              src="/profile-completion.webp"
              alt="Profile completion"
              width="224"
              height="224"
              className="h-[224px] w-auto object-contain mx-auto"
            />
            <div className="text-center space-y-4 mt-6">
              <h6 className="text-xl font-bold">Lengkapi profil dan berkas Anda!</h6>
              <div className="text-gray-600">
                Profil Anda belum lengkap. Mohon lengkapi data dan unggah berkas agar perusahaan dapat melihat informasi Anda saat melamar
                pekerjaan.
              </div>
            </div>
            <div className="mt-10 flex items-center justify-center text-center">
              <Button className="font-bold text-base p-6" asChild>
                <Link
                  href={
                    clientConfig?.config.siapkerjaAppUrl +
                    "/prohub/profile/completion?redirect_url=" +
                    clientConfig?.config.appUrl +
                    pathname
                  }
                >
                  Lengkapi Profil
                </Link>
              </Button>
            </div>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
